import React from "react";
import "./Faq.css";
import { FaqImage } from "./Image";


function Faqs() {
	return (
		<div className="faqs-page">
			<div className="main-section">
				<section className="faqs-list">
					<h2>Frequently asked questions</h2>
					{FaqImage}

					<li className="question">Q. Is there a callout charge? </li>
					<br></br>
					<li className="answers">
						A. - There is no callout charge for any labour totalling above £35,
						this includes all servicing. Jobs coming under this amount will be
						topped up to £35 and this is billed as a “callout charge"{" "}
					</li>
					<br></br>
					<li className="question">Q. Can I bring my bike to you? </li>
					<br></br>
					<li className="answers">
						A. No. At the moment we are operating a mobile repair service,
						collection and dropoff at your house or work only. This may be
						changing for the coming season so watch this space! If you don’t
						specifically need a mobile mechanic, consider trying your local
						shop.
					</li>
					<br></br>
					<li className="question">Q. Do you do small jobs? </li>
					<br></br>
					<li className="answers">
						A. Yes we can do pretty much anything you require. It may be more
						economical to get a few jobs done at the same time. Or better still,
						book at least a standard service and get the benefit of a
						professional experienced mechanic checking and adjusting the whole
						bike.
					</li>
					<br></br>
					<li className="question">Q. Do you re pair on site? </li>
					<br></br>
					<li className="answers">
						A. At the moment I can do inner tube / tyre replacement on site. If
						your bike has been serviced within the last few months and is in
						generally good condition we may be able to do some basic
						adjustments, but cannot carry out repairs or servicing on site.
					</li>
					<br></br>
					<li className="question">Q. Do you fix anything else? </li>
					<br></br>
					<li className="answers">
						A. We only work on bicycles, tricycles and the odd wheelchair tyre.
						We do not fix anything else.
					</li>
					<br></br>
					<li className="question">Q. How soon can you fit me in? </li>
					<br></br>
					<li className="answers">
						A. Depending on your location and our workload wait time for a
						pickup fluctuates from 0-14 days on average. Think ahead and get
						your bike serviced well in advance. Common times you may be caught
						out include : before a big cycling event (eg the Velo), before your
						child's "Bikeability” week / back to school, half term / school
						holidays, and any time in the spring / summer!.
					</li>
					<br></br>
					<li className="question">Q. How long does it take? </li>
					<br></br>
					<li className="answers">
						A. We aim to turn every service around in 7 days. This means
						whichever day your bike is collected it will be dropped off the same
						day the following week. This is a reasonable amount of time in which
						to triage your bike and report back to you with an accurate cost,
						source any parts your bike may require and do all of the work that
						may be necessary. In some cases the turnaround may be longer where
						parts are difficult to source, or special tools or other resources
						are needed.".
					</li>
					<br></br>
					<li className="question">Q. Can you do it quicker than 7 days? </li>
					<br></br>
					<li className="answers">
						A. If you have your bike serviced regularly and no parts need
						replacing then it may be possible to complete a service in less than
						7 days. However at the moment our pickup and dropoff schedule does
						not allow for returning individual bikes on an ad-hoc basis. SPREAD
						THE WORD TO YOUR FRIENDS AND NEIGHBOURS - once demand reaches a
						certain level in your area we will add a second round. This will
						reduce wait time, and allow the potential for returning easier jobs
						sooner (within 2 or 3 days)
					</li>
					<br></br>
					<li className="question">Q. Do you cover my area? </li>
					<br></br>
					<li className="answers">
						A. At the moment our area is limited to within the M5, M6, M42
						motorway loop. If you live just outside this area (within a mile or
						so) and need at least a standard service, then please get in touch
						and we will see what we can do. You can check if we cover your area
						by opening the booking form and starting to type your postcode
						(please include the space).
					</li>
					<br></br>
				</section>
			</div>
			

		</div>
	);
	
						};

export default Faqs;
